export const NEW_PATH = "new";
export const EDIT_PATH = ":id";

export const ROOT_PATH = "/";

export const COSTS_PATH = "costs";
export const SELECT_WORKSPACE_PATH = "select-workspace";
export const OPERATIONS_PATH = "operations";
export const ACTORS_PATH = "actors";
export const ROUTES_PATH = "routes";
export const ROOT_TRANSPORT = "transport";
export const DRIVERS_PATH = "transport/drivers";
export const VEHICLES_PATH = "transport/vehicles";
export const TRAILERS_PATH = "transport/trailers";
export const PRODUCTS_PATH = "products";
export const LPCOS_PATH = "lpcos";
export const OPERATIONS_TABLE_PATH = "table";
export const LEAD_TIMES_PATH = "lead-times";
export const CONFIGURE_LEAD_TIMES_PATH = "lead-times/configure";
export const CONFIGURE_LEAD_TIMES_MODAL_PATH = "configure";
export const KANBAN_PATH = "kanban";
export const TRASH_PATH = "trash";
export const ORDERS_MODAL_PATH = "orders";
export const PROCESSES_MODAL_PATH = "processes";
export const SETTINGS_PATH = "settings";
export const SETTINGS_USERS_PATH = "users";
export const SETTINGS_WORKSPACE_PATH = "workspace";
export const SETTINGS_CREDENTIALS_PATH = "credentials";
export const SETTINGS_NOTIFICATION_GROUPS_PATH = "notification-groups";
export const DASHBOARD_PATH = "dashboard";
export const NOT_AUTHORIZED_PATH = "not-authorized";
export const EXTERNAL_PATH = "external";
export const EXTERNAL_INVITE_PATH = ":token";
export const ROOT_INTEGRATIONS = "integrations";
export const INTEGRATIONS_DOCS_PATH = "integrations/docs";
export const INTEGRATIONS_LOGS_PATH = "integrations/logs";
export const ROOT_MARITIME_TRANSPORT_PATH = "maritime-transport";
export const MERCANTE_PATH = `${ROOT_MARITIME_TRANSPORT_PATH}/mercante`;
export const PORT_TERMINALS_PATH = `${ROOT_MARITIME_TRANSPORT_PATH}/port-terminals`;
export const GLOBAL_TRACKING_PATH = "tracking";
export const REQUEST_PATH = "requests";
export const DEFAULT_PAGE_PATH = OPERATIONS_PATH;
export const INSIGHTS_PATH = "insights";
export const ROOT_AGENTS = "agents";
export const AGENTS_EXECUTIONS = "agents/executions";

function path(root: string, sublink: string): string {
  return `${root}/${sublink}`;
}

export const OPERATION_PATHS = {
  table: path(OPERATIONS_PATH, OPERATIONS_TABLE_PATH),
  lead_times: path(OPERATIONS_PATH, LEAD_TIMES_PATH),
  configure_lead_times: path(OPERATIONS_PATH, CONFIGURE_LEAD_TIMES_PATH),
  kanban: path(OPERATIONS_PATH, KANBAN_PATH),
  costs: path(OPERATIONS_PATH, COSTS_PATH),
};

export const SETTINGS_PATHS = {
  settings: SETTINGS_PATH,
  users: path(SETTINGS_PATH, SETTINGS_USERS_PATH),
  workspace: path(SETTINGS_PATH, SETTINGS_WORKSPACE_PATH),
  credentials: path(SETTINGS_PATH, SETTINGS_CREDENTIALS_PATH),
  notification_groups: path(SETTINGS_PATH, SETTINGS_NOTIFICATION_GROUPS_PATH),
};
